import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import DocumentTitle from 'react-document-title';
import {Tab} from "@material-ui/core";
import {TabContext, TabList, TabPanel} from "@material-ui/lab";
import MobileUserAccountDetailsInfo from "./MobileUserAccountDetailsInfo";
import {useDispatch} from "react-redux";
import {useParams} from "react-router";
import {actions} from "../../actions/mobileUserAccountsActions";
import MobileUserAccountPaymentDemands from "./MobileUserAccountPaymentDemands/MobileUserAccountPaymentDemands";

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    'aria-controls': `wrapped-tabpanel-${index}`,
  };
}

const MobileUserAccountDetailsPage = () => {
  const dispatch = useDispatch();
  const {id} = useParams();


  const {t} = useTranslation()
  const [activeTab, setActiveTab] = useState('0');

  useEffect(() => {
    dispatch(actions.getDetails(id))
  }, [dispatch, id]);

  return (
    <DocumentTitle title={t('mobileUserAccounts.details.title')}>
      <div className="page">
        <TabContext value={activeTab}>
          <div style={{marginLeft: 20, marginRight: 20}}>

            <TabList onChange={(_, value) => (setActiveTab(value))}>
              <Tab value={'0'} label={t('mobileUserAccounts.details.header')} {...a11yProps(0)} />
              <Tab value={'1'} label="Windykacja" {...a11yProps(1)} />
            </TabList>
          </div>

          <TabPanel value={'0'} index={'0'}>
            <MobileUserAccountDetailsInfo/>
          </TabPanel>
          <TabPanel value={'1'} index={'1'}>
            <MobileUserAccountPaymentDemands/>
          </TabPanel>
        </TabContext>
      </div>
    </DocumentTitle>
  )
}

export default MobileUserAccountDetailsPage;
